import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../../hooks/useQueryParams";

export function TagsFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/tags/"
  );
  const tags = data?.results.filter((t) => t.is_active === true);
  return (
    <Picker
      isLoading={isLoading}
      label={t("Tags")}
      showActionBar
      selectionMode="multiple"
      selectedKeys={params.tags?.split(",") || []}
      onSelectionChange={(keys) => setParam("tags", Array.from(keys))}
      items={tags}
      testID="tags-filter-picker"
    />
  );
}
